import admin, {api} from '@/utils/http'
import { siteinfo } from './state'

const actions = {
  async initRule(acl) {
    this.resetSite()
    await this.fetchDict()
    await this.fetchSite()
    const roles = [...this.dict.roles]
    const rules = roles.reduce((rules, role) => {
      rules[role.id] = [...role.permission]
      return rules
    }, {
      '*': ['public'],
    })
    acl.setRules(rules)

    await this.auth.isLogin()
    acl.change(this.auth.user.roleID)
  },
  saveSettings() {
    const data = {
      isVerticalNavMenuActive: this.isVerticalNavMenuActive,
      mainLayoutType: this.mainLayoutType,
      navbarSearchAndPinList: this.navbarSearchAndPinList,
      reduceButton: this.reduceButton,
      verticalNavMenuWidth: this.verticalNavMenuWidth,
      verticalNavMenuItemsMin: this.verticalNavMenuItemsMin,
      theme: this.theme,
      themePrimaryColor: this.themePrimaryColor,
      navbarType: this.navbarType,
      navbarColor: this.navbarColor,
      footerType: this.footerType,
      routerTransition: this.routerTransition,
      hideScrollToTop: this.hideScrollToTop,
      disableThemeTour: this.disableThemeTour,
    }
    localStorage.setItem('settings', JSON.stringify(data))
  },
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth(width) {
    this.verticalNavMenuWidth = width
  },

  // The Navbar

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  updateTheme(val) {
    this.theme = val
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserRole(payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    this.updateUserInfo({userRole: payload.userRole})
  },
  async fetchDict() {
    const dict = await admin.get('/dict')
    dict.roleName = dict.roles.reduce((m, r) => {
      m[r.id] = r.name
      return m
    },{})
    dict.userRoles = dict.roles.filter(i => i.id !== 4 && i.id !== 1)
    dict.priceMap = {}
    dict.priceMap.qrExpire = dict.price.qrExpire.reduce((m, i) => {
      m[i.id] = i
      return m
    },{})
    dict.priceMap.material = dict.price.material.reduce((m, i) => {
      m[i.id] = i
      return m
    },{})

    this.dict = dict
  },
  getSticky(id) {
    return this.dict.price.sticky.find(i => i.id == id)
  },

  async fetchSite() {
    const site = await api.get('/siteinfo')
    this.site = {...siteinfo, ...site}
  },
  async resetSite() {
    this.site = siteinfo
  },

  // 第一个有权限的路由
  firstPerRoutePath() {
    const vm = this.$rootVM
    let url = ''
    const check = m => {
      if (url) return
      if (m.url) {
        const match = vm.$router.match(m.url)
        if (vm.$acl.check(match.meta.rule)) {
          url = match.path
        }
      }
    }
    this.navMenuItems.forEach(check)

    return url
  },
}

export default actions
